import { CheckoutData, checkoutDataToQuery } from '@wix/pricing-plans-router-utils';
import { IWixAPI } from '@wix/yoshi-flow-editor';

export function navigateToPlanCustomization(wixCodeApi: IWixAPI, checkoutData: CheckoutData) {
  const params = checkoutDataToQuery(checkoutData);
  return wixCodeApi.location.to?.('/plan-customization?' + params.toString());
}
